import _ from 'lodash';
import React from 'react';
import {ColoredBar} from './progressBar/ColoredBar';

export const ProgressItem = ({label, value, count = undefined, color}) => {
    const segments = [{value: value, percent: value, color: color}];
    return <div style={{marginTop: 8}}>
        <div style={{display: 'flex'}}>
            <div style={{flex: 1, paddingRight: 10}}>{label}</div>
            <div style={{fontWeight: 600}}>{_.round(value, 2)} %{count ? ` (${count})` : null}</div>
        </div>
        <div style={{marginTop: 3}}>
            <ColoredBar segments={segments}/>
        </div>
    </div>;
};

